import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  AddPinComponent,
  AddPropertyComponent,
  AddRetailerComponent,
  AddStuffComponent
} from './components/index';
import { MapsAddStuffService } from './maps-add-stuff.service';

// 3rd party
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PerfectScrollbarModule,
    ReactiveFormsModule
  ],
  declarations: [
    AddPinComponent,
    AddPropertyComponent,
    AddRetailerComponent,
    AddStuffComponent
  ],
  providers: [
    MapsAddStuffService,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ],
  exports: [AddStuffComponent]
})
export class MapsAddStuffModule { }



// WEBPACK FOOTER //
// ./src/app/modules/maps-add-stuff/maps-add-stuff.module.ts